import { root, id } from './network';

export const network = {
  ...root,
  id,
};
